import { render, staticRenderFns } from "./biztel.vue?vue&type=template&id=58b7f5e2&"
import script from "./biztel.vue?vue&type=script&lang=js&"
export * from "./biztel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports